import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { markStartup, StartupMark } from './app/core/startup-metrics';

// Posé AVANT le bootstrap : ce qui précède ce point est l'analyse du bundle,
// que l'on lit comme l'écart entre l'origine de la navigation et ce jalon.
markStartup(StartupMark.Bootstrap);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
